export const STATUSES = {
    EXPIRED: {
        label: 'Expired',
        appearance: 'default',
    },
    UNUSED: {
        label: 'Unused',
        appearance: 'success',
    },
    FULLY_USED: {
        label: 'Fully used',
        appearance: 'default',
    },
    PARTIALLY_USED: {
        label: 'Partially used',
        appearance: 'success',
    },
    DEACTIVATED: {
        label: 'Deactivated',
        appearance: 'default',
    },
};
